export default ({ request }) => ({
  masterCustomerListByUserApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/listByUser',
      method: 'post',
      data,
    })
  },
  masterCustomerSaveBaseApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/save/base',
      method: 'post',
      data,
    })
  },
  masterCustomerSaveContactsApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/save/contacts',
      method: 'post',
      data,
    })
  },
  masterCustomerCategoryListApi(data) {
    return request({
      url: '/digitalCenter/master/customer/category/list',
      method: 'post',
      data,
    })
  },
  masterCustomerCategoryDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/category/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerCategorySaveApi(data) {
    return request({
      url: '/digitalCenter/master/customer/category/save',
      method: 'post',
      data,
    })
  },
  masterCustomerCategoryDelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/category/del',
      method: 'post',
      data,
    })
  },
  masterCustomerBrandListApi(data) {
    return request({
      url: '/digitalCenter/master/customer/brand/list',
      method: 'post',
      data,
    })
  },
  masterCustomerBrandDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/brand/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerBrandSaveApi(data) {
    return request({
      url: '/digitalCenter/master/customer/brand/save',
      method: 'post',
      data,
    })
  },
  masterCustomerBrandDelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/brand/del',
      method: 'post',
      data,
    })
  },
  masterCustomerBrandOptionsApi(data) {
    return request({
      url: '/digitalCenter/master/customer/brand/options',
      method: 'post',
      data,
    })
  },
  masterCustomerBrandAddApi(data) {
    return request({
      url: '/digitalCenter/master/customer/brand/add',
      method: 'post',
      data,
    })
  },
  masterCustomerDepListApi(data) {
    return request({
      url: '/digitalCenter/master/customer/dep/list',
      method: 'post',
      data,
    })
  },
  masterCustomerDepDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/dep/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerDepSaveApi(data) {
    return request({
      url: '/digitalCenter/master/customer/dep/save',
      method: 'post',
      data,
    })
  },
  masterCustomerDepDelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/dep/del',
      method: 'post',
      data,
    })
  },
  masterCustomerSaveFinanceApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/save/finance',
      method: 'post',
      data,
    })
  },
  masterCustomerSaveFactoryInspectionApi(data) {
    return request({
      url: '/digitalCenter/masterCustomer/save/factoryInspection',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderListApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/list',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderTreeApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/tree',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderCreateApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/create',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderUpdateApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/update',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderDelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/del',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderChangeParentApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/changeParent',
      method: 'post',
      data,
    })
  },
  masterCustomerDocFactoryInspectionApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/factoryInspection',
      method: 'post',
      data,
    })
  },
  masterCustomerDocFactoryInspectionUploadApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/factoryInspection/upload',
      method: 'post',
      data,
    })
  },
  masterCustomerDocDetailApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/detail',
      method: 'post',
      data,
    })
  },
  masterCustomerDocUploadApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/upload',
      method: 'post',
      data,
    })
  },
  masterCustomerDocUpdateApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/update',
      method: 'post',
      data,
    })
  },
  masterCustomerDocDeactivateApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/deactivate',
      method: 'post',
      data,
    })
  },
  masterCustomerDocEnableApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/enable',
      method: 'post',
      data,
    })
  },
  masterCustomerDocChangeParentApi(data) {
    return request({
      url: '/digitalCenter/master/customer/doc/changeParent',
      method: 'post',
      data,
    })
  },
  masterCustomerFolderLevelApi(data) {
    return request({
      url: '/digitalCenter/master/customer/folder/level',
      method: 'post',
      data,
    })
  },
  customerReportBudgetYearApi({ budgetYear, custCode }) {
    return request({
      url: `/factory/rpt/budget/year/${budgetYear}/${custCode}`,
      method: 'GET',
    })
  },
  customerReportListOrderApi(data = {}) {
    return request({
      url: '/factory/report/orderlist/customer/listOrder',
      method: 'POST',
      data,
    })
  },
  customerReportListGoodsApi(data = {}) {
    return request({
      url: '/factory/report/orderlist/customer/list',
      method: 'POST',
      data,
    })
  },
  customerChangeLogListApi(data = {}) {
    return request({
      url: '/digitalCenter/customer/change/log/list',
      method: 'POST',
      data,
    })
  },
})
